import { CallCenter } from '../call-center';

const keyMessage: { [key: string]: string } = {
  CALL_CENTER: 'Central de Atendimento.',
};

const view: { [key: string]: React.ReactElement } = {
  CALL_CENTER: <CallCenter />,
};

export const getFormattedMessage = (message: string) => {
  const hasCallCenterMsg = message.includes(keyMessage.CALL_CENTER);
  const formattedMessage = hasCallCenterMsg ? message.replace(keyMessage.CALL_CENTER, '') : message;
  const componentView = hasCallCenterMsg ? view.CALL_CENTER : '';

  return {
    formattedMessage,
    componentView,
  };
};
